import { BREEDER_REFUND_POLICY } from 'dpl/breeder_account/utils/constants';

const DEPOSIT_SECURES_TEXT = {
  specific_puppy: 'a specific puppy',
  litter_spot: 'your spot in a litter',
  waitlist_spot: 'your spot on the waitlist'
};

const FINAL_PAYMENT_TIMING_TEXT = {
  before_pickup: 'before pickup',
  at_pickup: 'at pickup'
};

export function ensureCurrencyIsPresent(price) {
  if (price == null || Number.isNaN(price)) {
    return '';
  }

  return price.toString().startsWith('$') ? price : `$${price}`;
}

// dogName is only used for a specific_puppy deposit; omit it (e.g. in the
// deposit terms modal, which never names a dog) to get the generic clause.
export function getDepositSecuresText(depositSecures, dogName = null) {
  if (!depositSecures) {
    return null;
  }

  if (depositSecures === 'specific_puppy' && dogName) {
    return dogName;
  }

  return DEPOSIT_SECURES_TEXT[depositSecures] || null;
}

export function getFinalPaymentTimingText(finalPaymentTiming) {
  return FINAL_PAYMENT_TIMING_TEXT[finalPaymentTiming] || null;
}

// The legacy 'other' policy has no adjective form, so it's treated as unset.
export function getDepositRefundPolicyAdjective(depositRefundPolicy) {
  return depositRefundPolicy === BREEDER_REFUND_POLICY.REFUNDABLE ||
    depositRefundPolicy === BREEDER_REFUND_POLICY.NON_REFUNDABLE
    ? depositRefundPolicy
    : null;
}

export function getPaymentAndSupportListItems(amount, dogPayment = false) {
  const amountText = amount
    ? `${ensureCurrencyIsPresent(parseFloat(amount).toFixed(2))} `
    : '';

  return [
    `Your ${amountText}payment is fully covered by Good Dog Payment Protection`,
    `Our team will jump in to help if anything goes wrong`,
    dogPayment &&
      'Exclusive discounts on puppy essentials from Chewy, Rover, BarkBox and more',

    dogPayment &&
      'Lifetime access to our Puppy Training Program, including live coaching and a supportive community, valued at $235'
  ].filter(Boolean);
}

export function getBasicProtectionAndSupportListItems(
  amount,
  dogPayment = false
) {
  const amountText = amount
    ? `${ensureCurrencyIsPresent(parseFloat(amount).toFixed(2))} `
    : '';

  return [
    !dogPayment &&
      `Your ${amountText}payment is not covered by Good Dog Payment Protection`,
    dogPayment && 'Our team will not be able to mediate any issues',
    !dogPayment &&
      'Our team will not be able to support you if an issue arises',
    dogPayment && 'Lose access to puppy training & coaching',
    'Designed specifically for trusted friends & family'
  ].filter(Boolean);
}

export function isFormattedAmountZero(formattedAmount) {
  if (!formattedAmount) {
    return true;
  }

  const numericValue = parseFloat(
    formattedAmount.toString().replace(/[$,\s]/g, '')
  );

  if (Number.isNaN(numericValue)) {
    return true;
  }

  return numericValue === 0;
}
